// extracted by mini-css-extract-plugin
module.exports = {"desc":"_11349","content":"_10753"};